import angular from 'angular';

import { routesConfig } from './leads.routes';

import '../activity/AddNoteForm.directive';
import './list/LeadsList.directive';
import './leads.scss';

export default angular.module('leads', []).config(routesConfig);
